"use client";
import { usePathname } from "next/navigation";
import Nav from "./Nav";
import Foot from "./Foot";
import Banner from "./Banner";
import ContactTracker from "./ContactTracker";
import { Providers } from "../providers";

export default function LayoutWrapper({ children }) {
  const pathname = usePathname();
  const isInvoicePage = pathname?.startsWith("/invoice");
  const isAdminPage = pathname?.startsWith("/admin");

  // Admin and Invoice pages: no nav/footer, light theme only
  if (isInvoicePage || isAdminPage) {
    return (
      <Providers attribute="class" defaultTheme="light" enableSystem={false}>
        {children}
      </Providers>
    );
  }

  return (
    <Providers attribute="class" defaultTheme="dark" enableSystem>
      <ContactTracker />
      <Nav />
      <Banner />
      <main className="relative isolate">{children}</main>
      <Foot />
    </Providers>
  );
}
